import { render, staticRenderFns } from "./AssociatedContent.vue?vue&type=template&id=4b829510&"
import script from "./AssociatedContent.vue?vue&type=script&lang=js&"
export * from "./AssociatedContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports